import { type FragmentOf, graphql } from "gql.tada";

const RestaurantTagFragment = graphql(`
  fragment RestaurantTagFragment on RestaurantTag {
    __typename
    id
    title
    category
  }
`);

export default RestaurantTagFragment;

export type RestaurantTagType = FragmentOf<typeof RestaurantTagFragment>;
